import { AgencyLocationInfo } from 'src/app/modules/administration/constants/agency-location';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export interface AgencyAdminSubmitData {
  agencyLocationSk?: string;
  serviceStartTime?: string;
  serviceEndTime?: string;
  lunchStartTime?: string;
  lunchEndTime?: string;
  averageWaitTime?: number;
  dateFrequency?: number;
  totalAppointmentsMonday?: number;
  totalAppointmentsTuesday?: number;
  totalAppointmentsWednesday?: number;
  totalAppointmentsThursday?: number;
  totalAppointmentsFriday?: number;
  totalAppointmentsSaturday?: number;
  totalAppointmentsSunday?: number;
  totalStaffMonday?: number;
  totalStaffTuesday?: number;
  totalStaffWednesday?: number;
  totalStaffThursday?: number;
  totalStaffFriday?: number;
  totalStaffSaturday?: number;
  totalStaffSunday?: number;
  languages?: number[];
  bilingualPsychologist?: boolean | string;
  bilingualInterpreter?: boolean | string;
  onSite?: boolean | string;
  offSite?: boolean | string;
  serviceManhattan?: boolean | string;
  serviceBronx?: boolean | string;
  serviceBrooklyn?: boolean | string;
  serviceQueens?: boolean | string;
  serviceStatenIsland?: boolean | string;
  sheval?: boolean | string;
  psychoEval?: boolean | string;
  counseling?: boolean | string;
  pteval?: boolean | string;
  oteval?: boolean | string;
  operatingMDE?: boolean;
  location?: { siteLocation: AgencyLocationInfo };
  agencyTypeId?: number;
}

export class AgencyAdminSubmitModel {
  agencySk: string;
  agencyLocationSk: string;
  serviceStartTime?: string;
  serviceEndTime?: string;
  lunchStartTime?: string;
  lunchEndTime?: string;
  averageWaitTime?: number;
  dateFrequency?: number;
  totalAppointmentsMonday?: number;
  totalAppointmentsTuesday?: number;
  totalAppointmentsWednesday?: number;
  totalAppointmentsThursday?: number;
  totalAppointmentsFriday?: number;
  totalAppointmentsSaturday?: number;
  totalAppointmentsSunday?: number;
  totalStaffMonday?: number;
  totalStaffTuesday?: number;
  totalStaffWednesday?: number;
  totalStaffThursday?: number;
  totalStaffFriday?: number;
  totalStaffSaturday?: number;
  totalStaffSunday?: number;
  languages?: number[];
  bilingualPsychologist?: boolean;
  bilingualInterpreter?: boolean;
  onSite?: boolean;
  offSite?: boolean;
  serviceManhattan?: boolean;
  serviceBronx?: boolean;
  serviceBrooklyn?: boolean;
  serviceQueens?: boolean;
  serviceStatenIsland?: boolean;
  sheval?: boolean;
  psychoEval?: boolean;
  counseling?: boolean;
  pteval?: boolean;
  oteval?: boolean;
  siteLocation: AgencyLocationInfo;
  agencyTypeId?: number;
  operatingMDE?: boolean;
  constructor(data: AgencyAdminSubmitData) {
    // this.agencySk = data?.agencySk;
    this.agencyLocationSk = data?.agencyLocationSk;
    this.serviceStartTime = data?.serviceStartTime;
    this.serviceEndTime = data?.serviceEndTime;
    this.lunchStartTime = data?.lunchStartTime;
    this.lunchEndTime = data?.lunchEndTime;
    this.averageWaitTime = data?.averageWaitTime;
    this.dateFrequency = data?.dateFrequency;
    this.totalAppointmentsMonday = data?.totalAppointmentsMonday;
    this.totalAppointmentsTuesday = data?.totalAppointmentsTuesday;
    this.totalAppointmentsWednesday = data?.totalAppointmentsWednesday;
    this.totalAppointmentsThursday = data?.totalAppointmentsThursday;
    this.totalAppointmentsFriday = data?.totalAppointmentsFriday;
    this.totalAppointmentsSaturday = data?.totalAppointmentsSaturday;
    this.totalAppointmentsSunday = data?.totalAppointmentsSunday;
    this.totalStaffMonday = data?.totalStaffMonday;
    this.totalStaffTuesday = data?.totalStaffTuesday;
    this.totalStaffWednesday = data?.totalStaffWednesday;
    this.totalStaffThursday = data?.totalStaffThursday;
    this.totalStaffFriday = data?.totalStaffFriday;
    this.totalStaffSaturday = data?.totalStaffSaturday;
    this.totalStaffSunday = data?.totalStaffSunday;
    this.languages = data?.languages || [];
    this.bilingualPsychologist = this.toBool(data?.bilingualPsychologist);
    this.bilingualInterpreter = this.toBool(data?.bilingualInterpreter);
    this.onSite = this.toBool(data?.onSite);
    this.offSite = this.toBool(data?.offSite);
    this.serviceManhattan = this.toBool(data?.serviceManhattan);
    this.serviceBronx = this.toBool(data?.serviceBronx);
    this.serviceBrooklyn = this.toBool(data?.serviceBrooklyn);
    this.serviceQueens = this.toBool(data?.serviceQueens);
    this.serviceStatenIsland = this.toBool(data?.serviceStatenIsland);
    this.sheval = this.toBool(data?.sheval);
    this.psychoEval = this.toBool(data?.psychoEval);
    this.counseling = this.toBool(data?.counseling);
    this.pteval = this.toBool(data?.pteval);
    this.oteval = this.toBool(data?.oteval);
    this.siteLocation = data?.location?.siteLocation;
    this.agencyTypeId = data?.agencyTypeId;
    this.operatingMDE = this.toBool(data?.operatingMDE);
  }

  get id(): string {
    return this.agencySk;
  }

  private toBool(value: boolean | string | undefined): boolean {
    if (value === true || value === false) {
      return value;
    }
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
    return false;
  }

}
